import { Link } from "react-router-dom";

import { ReactComponent as LogoIcon } from "../../resources/icons/logo.svg";

const Footer: React.FC<{}> = () => {
  return (
    <div className="flex flex-col px-4 py-4 lg:px-16">
      <div className="flex justify-start items-baseline mb-8">
        <LogoIcon className="mr-1" />
        <Link className="navbar-brand mr-8 font-bold" to={"/"}>
          Build Connect
        </Link>
        <Link className="text-grey-800 nav-link mr-8" to={"/"}>
          Contact us
        </Link>
        <Link className="text-grey-800 nav-link" to={"/"}>
          Privacy Policy
        </Link>
      </div>
      <div className="text-grey-800 self-end">
        <p>© {new Date().getFullYear()} BuildConnect. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
